import React from "react";

const SvgInfoInCircle = props => <svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><circle cx={10} cy={10} r={9} stroke="currentColor" strokeWidth={2} /><circle cx={10} cy={6.27} r={1.4} fill="currentColor" /><line x1={10} y1={9} x2={10} y2={15.4} stroke="currentColor" strokeWidth={2} /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/info-in-circle_4a22d3.svg";
export { SvgInfoInCircle as ReactComponent };